import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";

const ProjectCounter = ({ total = 10 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 100; // 1.5 sec animation
    const stepTime = Math.max(Math.floor(duration / total), 30);

    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === total) clearInterval(timer);
    }, stepTime);

    return () => clearInterval(timer);
  }, [total]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={{ xs: 80, md: 150 }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: "bold",
          fontSize: { xs: "1.8rem", md: "3.2rem" },
          fontFamily: "'Orbitron', sans-serif",
          color: "#1976d2",
          textShadow: "2px 2px 8px rgba(0,0,0,0.25)",
          transition: "all 0.3s ease",
        }}
      >
        {count}
      </Typography>
    </Box>
  );
};

export default ProjectCounter;
